import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../_services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import {ConfirmationService, SelectItem} from 'primeng/api';
import { LocaleService } from 'src/app/_services/locale.service';
import * as jwt_decode from "jwt-decode";
import { GlobalService } from 'src/app/_services/global.service';
import { NotificationsService } from 'src/app/_services/notifications.service';


import { interval } from 'rxjs';
import { CookieService } from 'src/app/_services/cookie.service';

import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';
import { NONE_TYPE } from '@angular/compiler';
import { KeyValuePipe } from '@angular/common';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [ConfirmationService],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('openClose', [
      // ...
      state('open', style({
        opacity: 1,
        'display': 'block'
      })),
      state('closed', style({
        opacity: 0,
        'display': 'none'
      })),
      transition('open => closed', [
        animate('0.2s')
      ]),
      transition('closed => open', [
        animate('0.2s')
      ]),
    ]),
  ]
})
export class HeaderComponent implements OnInit {
  userPassowrdDimenticata='';
  showGiftcardSteps: boolean = false;
  displayGiftcardConnection: boolean = false;
  displayOptions: boolean = false;
  displayUserOptions: boolean = false;
  displaySupportOptions: boolean = false;

  languages: SelectItem[];
  decimalSeparators: SelectItem[];

  selectedLocale: any;
  selectedDecimalSeparator: any;
  selectedStore: any;

  showPasswordChange: boolean = false;
  oldPassword: string;
  newPassword: string;
  userPasswordModel: any = {};
  msgs: any;

  showOldPassword: boolean = false;
  showNewPassword: boolean = false;
  showNewPasswordRepeat: boolean = false;

  showModuliAttivi: boolean = false;
  moduliAttivi: any = [];

  sessionDuration=5; // in minuti
  
  constructor(
    private authService: AuthService,
    public cookie: CookieService,
    private router: Router,
    private translate: TranslateService,
    private session: LocaleService,
    public globalService: GlobalService,
    private confirmationService: ConfirmationService,
    public notificationsService: NotificationsService,
  

  ) {


    this.notificationsService.itemValue.subscribe((nextValue) => {
      
    });
  }

  ngOnInit() {
      
   

    this.initLanguages();
    //this.checkTasks();
    this.initDecimalSeparators();
   
    this.refreshKpi();

   
  }

  refreshKpi(){
    setInterval(()=>{
      let kpilist;
      if(this.globalService.loggedUser)
        kpilist=JSON.parse(localStorage.getItem('kpilistv4'+this.globalService.loggedUser.id));
      var kpilist_hp:any[];
      if(kpilist){
        kpilist_hp=kpilist.filter(item => item.isprimary ).map(item => {return item});
      }
      
      if(kpilist_hp){
        let newkpi:any;
        let ckpi:any;
        let cindex=0;
        kpilist_hp.forEach((k,index)=>{
          if(k.currentKpi){
            cindex=index;
          }
        });
        if(cindex==kpilist_hp.length-1){
          cindex=0;
        }else {
          cindex++;
        }
        
        ckpi=kpilist_hp[cindex];

      
        if(ckpi){
          let ckpivalue=0;
          if(ckpi.value){
          
            ckpivalue=ckpi.value;
          }
          this.authService.getkpi({id_user:this.globalService.loggedUser.id,kpiname:ckpi.name}).subscribe(data => {
            data.Result.forEach((d,ind)=>{
              if(d.name==ckpi.name){
                ckpi=data.Result[ind];
              }
            });
        

            if((ckpi)&&(ckpi.alert)&&(ckpivalue!=ckpi.value)){

              this.notificationsService.addMessage('far fa-exclamation-triangle', ckpi.name+": "+ckpi.value,'#FFF',  ckpi.color, new Date());
            }
            newkpi=kpilist_hp[cindex];
            kpilist.forEach((k,index)=>{
              k.currentKpi=false;
              if(k.name==ckpi.name){
                kpilist[index]=ckpi;

              }
              if(k.name==newkpi.name){
                k.currentKpi=true;
              }
            });
            this.globalService.kpilist=kpilist;
            
         

            this.globalService.kpilist_hp=kpilist.filter(item => item.isprimary ).map(item => {return item});
            localStorage.setItem('kpilistv4'+this.globalService.loggedUser.id,JSON.stringify(kpilist));
          });
        } else {
          newkpi=kpilist_hp[cindex];
          kpilist.forEach((k,index)=>{
            k.currentKpi=false;
            if(k.name==newkpi.name){
              k.currentKpi=true;
            }
          });
          this.globalService.kpilist=kpilist;
          this.globalService.kpilist_hp=kpilist.filter(item => item.isprimary ).map(item => {return item});
          localStorage.setItem('kpilistv4'+this.globalService.loggedUser.id,JSON.stringify(kpilist));
        }
      }
    }, 60*2*1000);  // OGNI 2 MINUTI RINFRESCA UN KPI
  }



  private checkTasks() {

    let assignedTasks: number = 0;
    let userId: number = +jwt_decode(localStorage.getItem('login_token')).user_id;

/*
    interval(10000).subscribe(x => {
      this.crmApiService.getTasks(params).subscribe(data => {
        taskList = data.Result;
        for (const task of taskList) {
          if (task.IDUtenteAssegnato === userId) {
            assignedTasks++;
          }
        }
        if (assignedTasks > 0) {
          //this.notificationsService.addMessage('fas fa-tasks', 'Nuove attività assegnate', new Date());
          this.notificationsService.notification = {
            icon:'fas fa-tasks',
            text:'nuove attività assegnate',
            color: '#DFF0FF',
            date:new Date(),
            read: false,
          };
        }
      });
    });

    */

  }

  private initLanguages() {
    this.languages = [
      {label: 'English', value: 'en'},
      {label: 'Italiano', value: 'it'},
    ];

    this.selectedLocale = this.globalService.locale;
  }

  private initDecimalSeparators() {
    this.decimalSeparators = [
      {label: 'Virgola', value: 'it'},
      {label: 'Punto', value: 'en'},
    ];

    this.selectedDecimalSeparator = this.globalService.decimalSeparator;
  }

  public logout(){
    this.confirmationService.confirm({
      header: 'Log Out',
      message: 'Sicuri di voler effettuare il logout?',
      icon: 'pi pi-sign-out',
      accept: () => {
        this.executeLogout();
      }
    });
  }

  public executeLogout() {
    this.globalService.showErrorDialog = false;
    if(this.globalService.loggedUser)
       localStorage.removeItem('kpilistv4'+this.globalService.loggedUser.id);
    this.authService.logout();
    this.router.navigateByUrl('/').then(() => {
      window.location.reload();
    });;
  }

  showSupportDialog() {
    this.displaySupportOptions = !this.displaySupportOptions;
    this.displayGiftcardConnection = false;
    this.displayOptions = false;
    this.displayUserOptions = false;
    this.notificationsService.displayMessages = false;
  }

  showGiftcardConnectionDialog() {
    this.displayGiftcardConnection = !this.displayGiftcardConnection;
    this.displaySupportOptions = false;
    this.displayOptions = false;
    this.displayUserOptions = false;
    this.notificationsService.displayMessages = false;
  }

  showMessagesDialog() {
    this.notificationsService.displayMessages = !this.notificationsService.displayMessages;
    this.displaySupportOptions = false;
    this.displayOptions = false;
    this.displayUserOptions = false;
    this.displayGiftcardConnection = false;
  }

  showOptionsDialog() {
    this.displayOptions = !this.displayOptions;
    this.displaySupportOptions = false;
    this.displayUserOptions = false;
    this.notificationsService.displayMessages = false;
    this.displayGiftcardConnection = false;
  }

  showUserOptionsDialog() {
    this.displayUserOptions = !this.displayUserOptions;
    this.displaySupportOptions = false;
    this.displayOptions = false;
    this.notificationsService.displayMessages = false;
    this.displayGiftcardConnection = false;
  }

  showPasswordChangeDialog() {
    this.showPasswordChange = true;
    this.userPasswordModel = {
      user: this.globalService.loggedUser.username,
      username: jwt_decode(localStorage.getItem('login_token')).user,
      VecchiaPassword: '',
      NuovaPassword: '',
      NuovaPasswordRepeat: ''
    }
  }


  public changePassword() {
    this.msgs = [];
    this.globalService.changePasswordMessage=[];
    if (this.isPasswordValida()) {
      
     
      this.authService.cambiaPasswordPrimaria(this.userPasswordModel).subscribe( data=> {
        //la chiamata va a buon fine, e la password è stata cambiata
        this.msgs.push({severity: 'success', detail: 'Password modificata con successo'});
        this.userPasswordModel.VecchiaPassword = '';
        this.userPasswordModel.NuovaPassword = '';
        this.userPasswordModel.NuovaPasswordRepeat = '';
        setTimeout(()=>{
          this.showPasswordChange = false;
        },3000);
      }, error => {
        console.error('error',error);
        //la chiamata non è andata a buon fine, segue la lista degli errori.
        if (error.error.Message === 'Errore nuova pwd < 5') {
          this.msgs.push({severity: 'error', detail: 'La nuova password deve essere di minimo 5 caratteri'});
        } else if (error.error.ExceptionMessage === 'Vecchia password non corretta!') {
          this.msgs.push({severity: 'error', detail: 'La password attuale non è corretta'});
        }
      });
    }
  }

  isPasswordValida(): boolean {
    var isValida: boolean = true;

    if (!this.userPasswordModel.NuovaPassword) {
      isValida = false;
      this.msgs.push({severity: 'error', detail: 'Obbligatorio inserire una nuova password'});
    }

    if (this.userPasswordModel.NuovaPassword !== this.userPasswordModel.NuovaPasswordRepeat) {
      isValida = false;
      this.msgs.push({severity: 'error', detail: 'Nuova Password e Ripeti Password non corrispondono'});
    }

    if (this.userPasswordModel.VecchiaPassword === this.userPasswordModel.NuovaPassword) {
      isValida = false;
      this.msgs.push({severity: 'error', detail: 'Le password non possono essere uguali'})
    }
    
    if (this.userPasswordModel.NuovaPassword.length<=8) {
      isValida = false;
      this.msgs.push({severity: 'error', detail: 'La password deve essere lunga lameno 8 caratteri'})
    }
       
    if (this.userPasswordModel.NuovaPassword.search(/[a-z]/i) < 0) {
      isValida = false;
      this.msgs.push({severity: 'error', detail: 'La password deve contenere almeno una lettera'})
    }
    if (this.userPasswordModel.NuovaPassword.search(/[0-9]/) < 0) {
      isValida = false;
      this.msgs.push({severity: 'error', detail: 'La password deve contenere almeno un numero'})
    }
    return isValida;
      
  }

  
  useLanguage() {
 
  }

  useLocale() {
   
    this.session.registerCulture(this.selectedDecimalSeparator);
    window.location.reload();
  }

}
